export default __webpack_public_path__ + "static/media/036-policeman.10daf575.svg";